import { useDropzone } from 'react-dropzone';

const FileDropzone = ({ onFileDrop }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'text/csv': ['.csv'],
    },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
      reader.onload = () => onFileDrop(reader.result, file.name);
      reader.readAsText(file);
    },
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #ccc',
        padding: '20px',
        textAlign: 'center',
        marginBottom: '20px',
        cursor: 'pointer',
      }}
    >
      <input {...getInputProps()} />
      <p>Glissez-déposez votre fichier CSV ici, ou cliquez pour sélectionner un fichier.</p>
    </div>
  );
};

export default FileDropzone;
